import React, { useState } from "react";
import "./PromoCodeComponent.css";
import { IoMdClose } from "react-icons/io";
import PromoCodeEditGroupModal from "./PromoCodeEditGroupModal";
import PromoCodeAddGroupModal from "./PromoCodeAddGroupModal";
import moment from "moment/moment";
import PromoCodeViewEmailModal from "./PromoCodeViewEmailModal";

const PromoCodeComponent = ({
  activeRadio,
  setActiveRadio,
  promoGroupData,
  handleGetGroupData,
  allUsers,
  groupEmailData,
  setSelectedEmail,
  setGroupEmailData,
  setShowEditGroupModal,
  showEditGroupModal,
  handleCloseEditGroupModal,
  handleSavePromoGroup,
  setSelectedGroup,
  setAddNewGroupModal,
  addNewGroupModal,
  handleCloseAddGroupModal,
  newAddedEmail,
  setNewAddedEmail,
  handleAddNewGroup,
  selectedGroup,
  newGroupName,
  setNewGroupName,
  promoCodeData,
  setViewEmailDataModal,
  viewEmailDataModal,
  handleCloseViewEmailDataModal,
  setEditEmailData,
  editEmailData,
  formData,
  setFormData,
  currentDate,
  handleAddPromo,
  handleDeletePromo,
  updateUserGroup,
  setEditPromoData,
  errorMessage,
  setErrorMessage,
}) => {
  return (
    <div className="banner_section" style={{ flex: 1 }}>
      <div className="container">
        <div className="row">
          <h4 className="common_heading">Add Promo Code</h4>

          <div className="col-lg-12 mb_commn_pd_0">
            <div className="promocode_section">
              <div className="Cus_shadow">
                <form className="form">
                  <div className="row">
                    <div className="col-lg-2 col-sm-6">
                      <div className="form-group">
                        <label htmlFor="promoCodeType">Promo Code Type</label>
                        <select
                          id="promoCodeType"
                          className="form-control"
                          onChange={(e) => {
                            setFormData({ ...formData, Type: e.target.value });
                            setErrorMessage({
                              ...errorMessage,
                              Type: "",
                            });
                          }}
                          value={formData?.Type}
                        >
                          <option value="" disabled selected>
                            Select Promo Code Type
                          </option>
                          <option value="point">Point</option>
                          <option value="money">Money</option>
                        </select>
                      </div>
                      {errorMessage?.Type ? (
                        <div className="validation-message">
                          {errorMessage?.Type}
                        </div>
                      ) : null}
                    </div>

                    <div className="col-lg-2 col-sm-6">
                      <div className="form-group">
                        <label htmlFor="promoCode">Promo Code</label>
                        <input
                          id="promoCode"
                          className="form-control"
                          type="text"
                          placeholder="Enter Promo Code"
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              PromoCode: e.target.value,
                            });
                            setErrorMessage({
                              ...errorMessage,
                              PromoCode: "",
                            });
                          }}
                          value={formData?.PromoCode}
                        />
                      </div>
                      {errorMessage?.PromoCode ? (
                        <div className="validation-message">
                          {errorMessage?.PromoCode}
                        </div>
                      ) : null}
                    </div>

                    <div className="col-lg-2 col-sm-6">
                      <div className="form-group">
                        <label htmlFor="minAmount">Amount or Points</label>
                        <input
                          id="minAmount"
                          className="form-control"
                          type="text"
                          placeholder="Enter Amount or Bid"
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              MinAmount: e.target.value,
                            });
                            setErrorMessage({
                              ...errorMessage,
                              MinAmount: "",
                            });
                          }}
                          value={formData?.MinAmount}
                        />
                      </div>
                      {errorMessage?.MinAmount ? (
                        <div className="validation-message">
                          {errorMessage?.MinAmount}
                        </div>
                      ) : null}
                    </div>

                    <div className="col-lg-2 col-sm-6">
                      <div className="form-group">
                        <label htmlFor="fromDate">From Date</label>
                        <input
                          id="fromDate"
                          type="date"
                          className="form-control"
                          placeholder="From Date"
                          min={currentDate}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              FromDate: moment(e?.target?.value).format(
                                "YYYY-MM-DDT00:00:00"
                              ),
                            });
                            setErrorMessage({
                              ...errorMessage,
                              FromDate: "",
                            });
                          }}
                          value={
                            moment(formData.FromDate).format("YYYY-MM-DD") || ""
                          }
                        />
                      </div>
                      {errorMessage?.FromDate ? (
                        <div className="validation-message">
                          {errorMessage?.FromDate}
                        </div>
                      ) : null}
                    </div>

                    <div className="col-lg-2 col-sm-6">
                      <div className="form-group">
                        <label htmlFor="toDate">To Date</label>
                        <input
                          id="toDate"
                          type="date"
                          className="form-control"
                          placeholder="To Date"
                          min={moment(formData.FromDate).format("YYYY-MM-DD")}
                          disabled={!formData?.FromDate}
                          value={
                            moment(formData.ToDate).format("YYYY-MM-DD") || ""
                          }
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              ToDate: moment(e?.target?.value).format(
                                "YYYY-MM-DDT00:00:00"
                              ),
                            });
                            setErrorMessage({
                              ...errorMessage,
                              ToDate: "",
                            });
                          }}
                        />
                      </div>
                      {errorMessage?.ToDate ? (
                        <div className="validation-message">
                          {errorMessage?.ToDate}
                        </div>
                      ) : null}
                    </div>

                    <div className="col-lg-2 col-sm-6">
                      <div className="form-group">
                        <label htmlFor="description">Description</label>
                        <input
                          id="description"
                          type="text"
                          className="form-control"
                          placeholder="Enter Description"
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              Description: e.target.value,
                            });
                            setErrorMessage({
                              ...errorMessage,
                              Description: "",
                            });
                          }}
                          value={formData?.Description}
                        />
                      </div>
                      {errorMessage?.Description ? (
                        <div className="validation-message">
                          {errorMessage?.Description}
                        </div>
                      ) : null}
                    </div>

                    <div className="col-lg-2 col-sm-12">
                      <div className="form-group">
                        <label>Promo Code Mode</label>
                        <div className="form-check">
                          <input
                            type="radio"
                            id="userListMode"
                            name="promoCodeMode"
                            value="userList"
                            className="promo_radio form-check-input"
                            checked={activeRadio == "userList"}
                            onClick={() => {
                              setActiveRadio("userList");
                              setFormData({
                                ...formData,
                                Mode: "userList",
                              });
                              setErrorMessage({
                                ...errorMessage,
                                Mode: "",
                              });
                            }}
                          />
                          <label
                            htmlFor="userListMode"
                            className="form-check-label"
                          >
                            Selected Users
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="radio"
                            id="limitedUsersMode"
                            name="promoCodeMode"
                            value="limitedUsers"
                            className="promo_radio form-check-input"
                            onClick={() => {
                              setActiveRadio("limitedUsers");
                              setFormData({
                                ...formData,
                                Mode: "limitedUsers",
                              });
                              setErrorMessage({
                                ...errorMessage,
                                Mode: "",
                              });
                            }}
                            checked={activeRadio == "limitedUsers"}
                          />
                          <label
                            htmlFor="limitedUsersMode"
                            className="form-check-label"
                          >
                            Limited Users
                          </label>
                        </div>
                      </div>
                      {errorMessage?.Mode ? (
                        <div className="validation-message">
                          {errorMessage?.Mode}
                        </div>
                      ) : null}
                    </div>

                    {activeRadio == "userList" ? (
                      <>
                        <div className="col-lg-2 col-sm-6">
                          <div className="form-group">
                            <label for="userGroup">Select Group</label>
                            <select
                              id="userGroup"
                              className="form-control"
                              onChange={(e) => {
                                const selectedValue = e?.target?.value;
                                const selectedItem = promoGroupData?.find(
                                  (item) => item?.Id === selectedValue
                                );
                                setSelectedGroup(selectedItem);
                                handleGetGroupData(selectedItem);
                              }}
                            >
                              <option value="" disabled="" selected="">
                                Select Group
                              </option>
                              {promoGroupData?.map((item) => {
                                return (
                                  <option value={item?.Id}>
                                    {item?.GroupName}
                                  </option>
                                );
                              })}
                              ={" "}
                            </select>
                          </div>
                        </div>
                        {selectedGroup ? (
                          <>
                            <div className="col-lg-2 col-sm-12">
                              <div className="form-group">
                                <label for="userList">Add More Users</label>
                                <select
                                  name=""
                                  id=""
                                  className="form-control"
                                  onChange={(e) => {
                                    const selectedValue = e?.target?.value;
                                    const selectedItem = allUsers?.find(
                                      (item) => item?.Id === selectedValue
                                    );
                                    setSelectedEmail(selectedItem);
                                    const checkEmail = groupEmailData?.find(
                                      (i) =>
                                        i.trim() === selectedItem?.Email.trim()
                                    );
                                    if (!checkEmail) {
                                      const filter = [
                                        ...groupEmailData,
                                        selectedItem?.Email,
                                      ];
                                      setGroupEmailData(filter);
                                    }

                                    e.target.value = "";
                                  }}
                                >
                                  <option value="">Select Email</option>
                                  {allUsers?.map((item) => {
                                    return (
                                      <option value={item?.Id}>
                                        {item?.Email ? item?.Email : null}
                                      </option>
                                    );
                                  })}
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-2 col-sm-6 col-12">
                              <button
                                type="button"
                                className="btn btn-primary common_btn_pd promo_add_new_gp"
                                onClick={() => {
                                  setShowEditGroupModal(true);
                                }}
                              >
                                Edit Group
                              </button>
                            </div>
                          </>
                        ) : null}

                        <div className="col-lg-2 col-sm-6 col-12">
                          <button
                            type="button"
                            className="common_btn btn-primary btn promo_add_new_gp common_btn_pd"
                            onClick={() => setAddNewGroupModal(true)}
                          >
                            Add New Group
                          </button>
                        </div>
                      </>
                    ) : activeRadio == "limitedUsers" ? (
                      <>
                        <div className="col-lg-3 col-sm-6">
                          <div className="form-group">
                            <label for="numberOfUsers">
                              No of Users Can Use
                            </label>
                            <input
                              id="numberOfUsers"
                              className="form-control"
                              type="number"
                              placeholder="Enter Number of Users"
                            />
                          </div>
                        </div>
                      </>
                    ) : null}
                    {groupEmailData?.length ? (
                      <div className="col-lg-12">
                        <div className="pro_selected_user">
                          <div className="form-group">
                            <label>Selected Users</label>
                            <div className="row">
                              {groupEmailData?.map((item) => {
                                return (
                                  <div className="col-lg-3 col-md-4 col-sm-6 mb-2">
                                    <div className="selected-user d-flex align-items-center">
                                      <input
                                        type="text"
                                        className="form-control me-2"
                                        readonly=""
                                        value={item}
                                      />
                                      <IoMdClose
                                        className="cross_butt_email"
                                        onClick={() => {
                                          const filter = groupEmailData?.filter(
                                            (i) => i !== item
                                          );
                                          setGroupEmailData(filter);
                                        }}
                                      />
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    <div className="col-lg-12 col-sm-6 col-12">
                      <button
                        type="button"
                        className="common_btn btn-primary btn common_btn_pd"
                        onClick={handleAddPromo}
                      >
                        Add Promo Code
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="promocode_table">
          <div className="row">
            <div className="col-lg-12 mb_commn_pd_0">
              <div className="table-responsive table-sm custom-table">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Promo Code</th>
                      <th>Minimum Amount</th>
                      <th>From Date</th>
                      <th>To Date</th>
                      <th>Description</th>
                      <th>No. of Users Can Use</th>
                      <th>Active</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {promoCodeData?.map((item, index) => {
                      return (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{item?.PromoCode}</td>
                          <td>{item?.MinAmount}</td>
                          <td>{moment(item?.FromDate).format("DD/MM/YYYY")}</td>
                          <td>{moment(item?.ToDate).format("DD/MM/YYYY")}</td>
                          <td>{item?.Description}</td>
                          <td>
                            {item?.NumberOfUsers}
                            {item?.Emails ? (
                              <button
                                type="button"
                                className="common_btn view-data-btn btn-primary"
                                onClick={() => {
                                  setEditPromoData(item);
                                  setEditEmailData(item?.Emails.split(","));
                                  setViewEmailDataModal(true);
                                }}
                              >
                                View Detail
                              </button>
                            ) : null}
                          </td>
                          <td>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              disabled=""
                              checked={item?.Active}
                            />
                          </td>
                          <td>
                            <button
                              type="button"
                              className="common_btn btn-primary"
                              onClick={() => {
                                setFormData({
                                  ...formData,
                                  Type: item?.Type,
                                  PromoCode: item?.PromoCode,
                                  MinAmount: item?.MinAmount,
                                  FromDate: item?.FromDate,
                                  ToDate: item?.ToDate,
                                  Description: item?.Description,
                                  Mode: item?.Mode,
                                  NumberOfUsers: item?.NumberOfUsers,
                                  Active: item?.Active,
                                });
                                setActiveRadio(item?.Mode);
                              }}
                            >
                              Edit
                            </button>
                            <button
                              type="button"
                              className="common_btn btn-danger"
                              onClick={() => handleDeletePromo(item)}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PromoCodeEditGroupModal
        showEditGroupModal={showEditGroupModal}
        handleCloseEditGroupModal={handleCloseEditGroupModal}
        allUsers={allUsers}
        setSelectedEmail={setSelectedEmail}
        groupEmailData={groupEmailData}
        setGroupEmailData={setGroupEmailData}
        handleSavePromoGroup={handleSavePromoGroup}
      />
      <PromoCodeAddGroupModal
        addNewGroupModal={addNewGroupModal}
        handleCloseAddGroupModal={handleCloseAddGroupModal}
        allUsers={allUsers}
        newAddedEmail={newAddedEmail}
        setNewAddedEmail={setNewAddedEmail}
        handleAddNewGroup={handleAddNewGroup}
        newGroupName={newGroupName}
        setNewGroupName={setNewGroupName}
      />
      <PromoCodeViewEmailModal
        viewEmailDataModal={viewEmailDataModal}
        handleCloseViewEmailDataModal={handleCloseViewEmailDataModal}
        allUsers={allUsers}
        editEmailData={editEmailData}
        setEditEmailData={setEditEmailData}
        updateUserGroup={updateUserGroup}
      />
    </div>
  );
};

export default PromoCodeComponent;
